export default {
    primary: {
        base: '#24374b',
        lighten5: '#2d4a64',
        lighten4: '#2a465f',
        lighten3: '#28435a',
        lighten2: '#263f55',
        lighten1: '#263b50',
        darken1: '#1f3146',
        darken2: '#202e41',
        darken3: '#1e2a3c',
        darken4: '#1b2237',
    },
    secondary: {
        base: '#b7c048',
        lighten5: '#d0d94f',
        lighten4: '#cbd44e',
        lighten3: '#c6cf49',
        lighten2: '#c1ca4d',
        lighten1: '#bcc548',
        darken1: '#b2bb46',
        darken2: '#adb647',
        darken3: '#a8b143',
        darken4: '#a3ac42',
    },
    accent: {
        base: '#f18932',
        lighten5: '#f18932',
        lighten4: '#f18932',
        lighten3: '#f18932',
        lighten2: '#f18932',
        lighten1: '#f18932',
        darken1: '#f18932',
        darken2: '#f18932',
        darken3: '#f18932',
        darken4: '#f18932',
    },
}